import React from 'react';

/**
 * Aggregates for the Firebase Feedback tab (feature 067-user-feedback-tabs).
 *
 * Computed over the CURRENT FILTERS, so the cards can never disagree with the list beneath them.
 *
 * The average is taken over RATED records only. A third of this collection predates the app
 * asking for a rating; counting those as zero would drag the figure down by roughly a third and
 * quietly misreport how members feel about the product.
 */
export default function FirebaseFeedbackSummaryPanel({ summary }) {
  if (!summary) return null;

  const total = summary.total || 0;
  const rated = summary.rated || 0;
  const average = summary.average_rating;

  return (
    <section className="au-cards ff-summary" aria-label="Feedback summary">
      <div className="au-card">
        <span className="au-card__label">Total messages</span>
        <span className="au-card__value">{total}</span>
        <span className="au-card__sub">for the current filters</span>
      </div>

      <div className="au-card">
        <span className="au-card__label">Average rating</span>
        <span className="au-card__value">
          {average === null || average === undefined ? '—' : average}
        </span>
        <span className="au-card__sub">
          {rated ? `across ${rated} rated message${rated === 1 ? '' : 's'}` : 'none rated yet'}
        </span>
      </div>

      <div className="au-card">
        <span className="au-card__label">Unrated</span>
        <span className="au-card__value">{Math.max(0, total - rated)}</span>
        <span className="au-card__sub">sent before the app asked for a rating</span>
      </div>
    </section>
  );
}
